import React from 'react';
import Button from '@material-ui/core/Button';

export default function ButtonMaterial({ children, ...rest }) {
  return <Button {...rest}>{children}</Button>;
}
